import * as actionTypes from './actionTypes';
import getFilteredRows from './getFilteredRows';

// SYNCHRONOUS ACTIONS
export const loadGrid = {
  request: ({ gridContext }) => {
    return gridContext.dispatch({ type: actionTypes.LOAD_GRID.REQUEST });
  },
  success: ({ gridContext, payload }) => {
    return gridContext.dispatch({
      type: actionTypes.LOAD_GRID.SUCCESS,
      payload
    });
  },
  failure: ({ gridContext }) => {
    return gridContext.dispatch({ type: actionTypes.LOAD_GRID.FAILURE });
  }
};

export const clearFilter = ({ gridContext, payload }) =>
  gridContext.dispatch({ type: actionTypes.CLEAR_FILTER, payload });

export const saveFilters = ({ gridContext, payload }) =>
  gridContext.dispatch({ type: actionTypes.SAVE_FILTER, payload });

export const resetFilters = ({ gridContext }) =>
  gridContext.dispatch({ type: actionTypes.RESET_FILTERS });

export const updateUnappliedFilters = ({ gridContext, payload }) =>
  gridContext.dispatch({ type: actionTypes.UPDATE_UNAPPLIED_FILTERS, payload });

export const saveSort = ({ gridContext, payload }) =>
  gridContext.dispatch({ type: actionTypes.SAVE_SORT, payload });

export const saveColumn = ({ gridContext, payload }) =>
  gridContext.dispatch({
    type: actionTypes.SAVE_COLUMN,
    payload: {
      ...payload,
      // Filter out columns from views that are null
      columnState: payload?.columnState?.filter(Boolean) || gridContext.columnState,
      columnsWithoutActions:
        payload?.columnsWithoutActions?.filter(Boolean) || gridContext.columnsWithoutActions
    }
  });

export const changeSavedView = ({ gridContext, payload }) =>
  gridContext.dispatch({
    type: actionTypes.CHANGE_SAVED_VIEW,
    payload: {
      ...payload,
      // Filter out columns from views that are null
      columnState: payload?.columnState?.filter(Boolean) || gridContext.columnState,
      columnsWithoutActions:
        payload?.columnsWithoutActions?.filter(Boolean) || gridContext.columnsWithoutActions
    }
  });

export const addUserView = ({ dispatch, payload }) =>
  dispatch({ type: actionTypes.ADD_USER_VIEW, payload });

// ASYNCHRONOUS ACTIONS
// NOTE: Maybe handle loadGrid api request within asynchronous action pattern

export const loadMore = {
  request: async ({ formattedColumnDefs, gridContext }) => {
    gridContext.dispatch({ type: actionTypes.LOAD_MORE.REQUEST });
    setTimeout(() => loadMore.success({ formattedColumnDefs, gridContext }), 500);
  },
  success: ({ formattedColumnDefs, gridContext }) => {
    const { columnState, dispatch, filterState, page, pageSize, sortState, totalData } =
      gridContext;
    const { paginatedData, totalRows } = getFilteredRows({
      columnState,
      filterState,
      formattedColumnDefs,
      sortState,
      page: page + 1,
      pageSize,
      rows: totalData
    });
    dispatch({
      type: actionTypes.LOAD_MORE.SUCCESS,
      payload: {
        page: page + 1,
        data: paginatedData,
        totalRows
      }
    });
  },
  failure: ({ gridContext }) => {
    gridContext.dispatch({ type: actionTypes.LOAD_MORE.FAILURE });
  }
};
